import axios from "axios";

export const LOGIN = "admin/auth/login";
export const REFRESH_TOKEN = "admin/auth/refresh-token";
export const LIST_USER = "admin/info/list-user";
export const LIST_USER_EXCEL = "admin/info/list-user/export-excel";
export const LIST_ADMIN = "admin/info/list";
export const REGISTER = "admin/auth/register";
export const LOCK_USER = "admin/auth/lock-user";
export const LOCK_ADMIN = "admin/auth/lock";
export const UNLOCK_USER = "admin/auth/unlock-user";
export const UNLOCK_ADMIN = "admin/auth/unlock";
export const CONVERSION_HIS = "admin/info/exchange-history";
export const CONVERSION_HIS_EXCEL = "admin/info/exchange-history/export-excel";
export const PLAY_HIS = "admin/info/current-turns";
export const PLAY_HIS_EXCEL = "admin/info/current-turns/export-excel";
export const GAMING_HIS = "admin/info/war-zone-history";
export const GAMING_HIS_EXCEL = "admin/info/war-zone-history/export-excel";
export const CONFIG = "admin/info/war-zone-config";
export const UPDATE_CONFIG = "admin/info/war-zone-config/bulk";
export const UPDATE_TURN_USER = "admin/info/update-user-turns";
export const LIST_RANK = "admin/info/war-zone/played-users";
export const UPDATE_USER_FAKE = "admin/info/war-zone/fake-users";
// Popup trúng thưởng lớn (giống COHON user-fake-notifications)
export const LIST_USER_FAKE = "admin/info/pop-up/add-user-fake";
export const ADD_USER_FAKE = "admin/info/pop-up/add-user-fake";
export const EDIT_USER_FAKE = "admin/info/pop-up/add-user-fake";
export const DELETE_USER_FAKE = "admin/info/pop-up/add-user-fake";
export const LIST_REWARD_CLAIM = "admin/info/war-zone/reward-claims";

// Dashboard statistics
export const DAILY_PARTICIPANTS = "admin/info/daily-participants";
export const VIP_USER_COUNTS = "admin/info/vip-user-counts";
export const VIP_TOTAL_SCORES = "admin/info/vip-total-scores";
export const SUMMARY_STATS = "admin/info/summary-stats";
export const DEPOSIT_STATS = "admin/info/deposit-stats";
export const TOTAL_SCORE_STATS = "admin/info/total-score-stats";

//--------------
const baseURL = "https://888b-api-quockhanh.tlj129.com/api/v1";

const API = axios.create({
  baseURL: baseURL,
  timeout: 100000,
  headers: {
    "Content-Type": "application/json",
  },
});

const auth = localStorage.getItem("auth");
if (auth) {
  API.defaults.headers.common["Authorization"] =
    JSON.parse(auth).tokenType + " " + JSON.parse(auth).accessToken;

  API.interceptors.response.use(undefined, (err) => {
    const error = err.response;
    // if error is 401
    if (error.status === 401 || error.status === 403) {
      refreshToken(JSON.parse(auth).refreshToken)
    } else {
      return Promise.reject(error);
    }
  });
}

const refreshToken = async (refreshToken) => {
  const params = {
    refreshToken: refreshToken
  };

  await API.post(REFRESH_TOKEN, params)
    .then((response) => {
      if (response.data) {
        const data = response?.data.data;
        const dataAuth = {
          tokenType: "Bearer",
          accessToken: data?.token,
          refreshToken: data?.refreshToken,
          username: data?.username,
          role: data?.role,
        };
        localStorage.setItem("auth", JSON.stringify(dataAuth));
        window.location.reload();
      } else {
        localStorage.clear();
        window.location.assign("/login");
      }
    })
    .catch((error) => {
      console.log(error);
      localStorage.clear();
      window.location.assign("/login");
    });
};

export default API;
